// @flow strict

/**
 * The versions of minchem organized by traditional naming,
 * OLD indicates the version from 1980s
 * LEGACY is this repository
 * MFE is the first version of the monorepo's minchem microfrontend
 */
export const MinChemVersions = {
    OLD: 0,
    LEGACY: 1,
    MFE: 2,
    MFEv4: 4,
}

/**
 * Returns true when a circuit version should be handled by the MinChem MFE.
 * Every version from MFE onward (MFE, MFEv4, and any future version) is
 * redirected to the microfrontend; only OLD and LEGACY stay on the legacy UI.
 */
export const isMinChemMfeVersion = (version: ?number): boolean =>
    version != null && version >= MinChemVersions.MFE;
